import React, { useState  } from "react";
import "./style.scss";
import Icon from "../icons";
import {formatPhoneNumber } from "../../helpers/utility"
import Dropdown from "../dropDown"
import config from "../../config";

const Header = (props) => {
    const [dropdown, setDropdown] = useState(false);
    const paymentMethod=()=>{
        props.paymentMethod()
        setDropdown(!dropdown)
    }
    const logout=()=>{
        props.logout()
        setDropdown(!dropdown)
    }
    const contact=()=>{
       // window.open("mailto:help@gosite.com", '_blank');
        props.handleChat()
        setDropdown(!dropdown)
    }
    const goToPage=()=>{
        if(props.backTositeUrl){
            window.location.replace(props.backTositeUrl)
        }
    }
    return (
        <header className="main-header">
            <div className="container">
                <div className="main-header-content h-100 d-sm-flex justify-content-between align-items-center relative">
                <div className="back-to-site">
                    {/**
                     * Currently and tempoarily, v3 websites are published in one S3 bucket in a directory represented by id (ex: https://my.gosite.build/60ad025660c39f1a57e860f8/)
                     * Cookies refUrl doesn't get the the id path so going back would take end users to an invalid page
                     * So we want to hide the "Back to Site" button since the instant sites will open a new tab for the end-user dashboard
                     */}
                    {props.backTositeUrl && props.backTositeUrl !=="" && props.backTositeUrl !== config.publishedV3SitesUrl ?
                    <div onClick={goToPage}>
                     <i className="icon-arrowleft"><Icon name="arrowLeft" /></i><span className="d-none d-sm-inline-block pl-5 v-middle">BACK TO SITE</span>
                     </div>
                     :null}
                </div>
                {props.user && props.user.token ?
                <div className="header-right-dropdown dropdown">
                    <Dropdown handleClickOutside={()=>setDropdown(false)} >
                    <div className="dropdown-btn" onClick={ () => { dropdown? setDropdown(false) : setDropdown(true)  }}>
                      { props.loginType && (props.loginType === "inv" || props.loginType === "gp") && props.user && props.user.user && props.user.user.customer_email ? props.user.user.customer_email : props.loginType && (props.loginType === "inv" || props.loginType === "gp") && props.user && props.user.user && props.user.user.customer_phone ? formatPhoneNumber(props.user.user.customer_phone.replace("+1","")) :  props.loginType === "mobile" && props.user.user.customer_phone ? formatPhoneNumber(props.user.user.customer_phone.replace("+1","")): props.loginType && props.loginType === "email" &&  props.user.user.customer_email ? props.user.user.customer_email : ""}<span className="caret-down ml-5"></span>
                    </div>
                    {dropdown ? (
                    <ul className="dropdown-menu right-0">
                        <li onClick={contact} className="dropdown-menu-item pl-25">Contact Support</li>
                        <li onClick={paymentMethod} className="dropdown-menu-item  pl-25">Payment Methods</li>
                        <li onClick={logout} className="dropdown-menu-item  pl-25">Logout</li>
                    </ul>
                    ) : null}
                    </Dropdown>
                </div>
                :null}
                </div>

            </div>
        </header>
    )
};

export default Header;



